import qs from "qs";

/**
 * This helper ensures we return either a string or undefined as the parameter value.
 * when there's duplicate url param keys, qs.parse returns an array of all those values for that param key,
 * which might confuse our attributions. We want only one value per param.
 * If an array, we return the first non-emppty element of that array.
 */
export const parseQueryString = (
  parameter: string,
  location: Window["location"],
) => {
  const result = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  })[parameter];
  if (typeof result === "string") return result;
  if (Array.isArray(result)) {
    const first = [...result].filter((item: unknown) => item)[0];
    if (typeof first === "string") return first;
  }
  return undefined;
};
